import {
  Box,
  Grid,
  Typography,
  Button,
  IconButton,
  Rating,
  Container,
  Card,
  CardContent,
  TextField,
  Divider,
  Avatar,
  DialogTitle,
  Dialog,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import EmailIcon from "@mui/icons-material/Email";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useEffect, useRef, useState } from "react";

import Salon_img from "../../assets/img/salon_img.png";
import Clock_icon from "../../assets/img/icons/clock_icon_black.png";
import Location_icon from "../../assets/img/icons/location_icon.png";
import Mail_icon from "../../assets/img/icons/mail_icon.png";
import Avatar_Img from "../../assets/img/icons/avatar_img.png";

import Details_icon from "../../assets/img/icons/Info_icon.png";
import Profile_icon from "../../assets/img/icons/profile_icon.png";
import Enquiry_icon from "../../assets/img/icons/whatsapp_icon.png";
import Map_icon from "../../assets/img/icons/map_icon.png";

import Review_user_img from "../../assets/review_user_img.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import categoryCard1 from "../../assets/swiperImage.png";
import categoryCard2 from "../../assets/swiperImage.png";
import categoryCard3 from "../../assets/swiperImage.png";
import categoryCard4 from "../../assets/swiperImage.png";
import { useDispatch, useSelector } from "react-redux";
import { getReview } from "../reviewRating/reviewAndRatingApi";
import { useNavigate } from "react-router";
import { removeFavProduct, setfavProduct } from "../../app/store/reducer";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import Footer from "../../common/Footer";
import CloseIcon from "@mui/icons-material/Close";
import ShareIcon from "@mui/icons-material/Share";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { routePath } from "../../constants/routePath";
import SEO from "../../common/SEO";
export const SalonPage = () => {
  const offersRef = useRef(null);
  const offersCarousel = [
    { image: categoryCard1, text: "Offer valid till 31 Jul 2025" },
    { image: categoryCard2, text: "Offer valid till 31 Aug 2025" },
    { image: categoryCard3, text: "Offer valid till 30 Sep 2025" },
    { image: categoryCard4, text: "Offer valid till 15 Oct 2025" },
    { image: categoryCard4, text: "Offer valid till 15 Oct 2025" },
    { image: categoryCard4, text: "Offer valid till 15 Oct 2025" },
    { image: categoryCard4, text: "Offer valid till 15 Oct 2025" },
  ];
  // const [value, setValue] = (useState < number) | (null > 0);
  const [reviewText, setReviewText] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [reviews, setReview] = useState([]);
  const [visibleReviews, setVisibleReviews] = useState(5);
  const incrementCount = 5; // how many more to show each time
  const [open, setOpen] = useState(false);
  const handleShowMore = () => {
    setVisibleReviews((prev) =>
      Math.min(prev + incrementCount, reviews.length),
    );
  };

  const handleShowLess = () => {
    setVisibleReviews(5); // reset to default
  };

  const details = useSelector((state) => state.reducer.detail);
  useEffect(() => {
    if (details) {
      getReview({ billerId: parseFloat(details.id) }, (d) => {
        let dd = d?.data?.data?.list;
        console.log("res dd", d?.data?.data?.list);
        setReview(dd);
        console.log(dd, "reviewssssss");
      });
    }
    console.log(details, "detailsssssssss");
  }, [details]);

  const mediaLinks = [
    {
      name: "Google.com",
      icon: "https://img.icons8.com/color/48/google-logo.png",
    },
    {
      name: "facebook.com",
      icon: "https://img.icons8.com/color/48/facebook-new.png",
    },
    {
      name: "instagram.com",
      icon: "https://img.icons8.com/color/48/instagram-new.png",
    },
    {
      name: "youtube.com",
      icon: "https://img.icons8.com/color/48/youtube-play.png",
    },
    {
      name: "linkedin.com",
      icon: "https://img.icons8.com/color/48/linkedin.png",
    },
    {
      name: "twittwer.com",
      icon: "https://img.icons8.com/color/48/twitter--v1.png",
    },
    {
      name: "pinterest.com",
      icon: "https://img.icons8.com/color/48/pinterest--v1.png",
    },
    {
      name: "Website.com",
      icon: "https://img.icons8.com/ios-filled/50/internet.png",
    },
    {
      name: "Other Links",
      icon: "https://img.icons8.com/ios-filled/50/link--v1.png",
    },
  ];

  const favorites = useSelector((state) => state.reducer.favProduct) || [];

  const isFavorited = favorites.some(
    (item) => item.billerId === details.billerId,
  );
  console.log(details, "FULL DETAILS BEFORE DISPATCH");

  const handleFavoriteClick = () => {
    if (isFavorited) {
      dispatch(removeFavProduct(details.billerId));
    } else {
      dispatch(setfavProduct(details)); // ✅ Save entire object
    }
  };

  return (
    <>
      <SEO
        title="Elegant Prime"
        description="All in One Basic Software for billing, inventory, and business management. Perfect solution for small and medium businesses."
        keywords="All-in-One Salon Management Software – POS, CRM & Billing, Salon & Spa Software – streamline operations, retain clients, boost revenue, Billing & Inventory Management Software for salons, Appointment Scheduling App for salons & spas,
Salon CRM Software India – customer retention made easy, Online Salon Booking System for clients, Loyalty Program Features to reward & retain customers, Staff Scheduling Software – manage beauticians & salon staff with ease,
Beauty Parlour Software with GST Billing – fast, compliant billing, Cloud-based Salon Management System – access anywhere, anytime
Salon Marketplace Integration – sell beauty products & services online, Best salon management app for parlours,
Best appointment scheduling app for salons, Affordable salon management software India, Mobile app for salon business growth,
Beauty parlour software India, Salon billing software with GST, Best salon management app, Salon staff scheduling software"
        canonical="https://elegantprime.in/salon"
        schema={{
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          name: "All in One Basic Software",
          applicationCategory: "BusinessApplication",
          operatingSystem: "Web, Windows, Mac",
        }}
      />
      <Box container>
        {/* Back Button */}

        <IconButton
          size="small"
          sx={{
            mb: { xs: 1, sm: 2 },
            mt: { xs: 1, sm: 6 },
            mx: { sm: 10, xs: 2 },
          }}
          onClick={() => navigate(routePath.SERVICESLIST)}
        >
          <KeyboardBackspaceIcon sx={{ color: "#01008B", fontSize: "30px" }} />
        </IconButton>
        <Container maxWidth="lg">
          <Box sx={{ px: { sm: 3, xs: 0 }, py: 1 }}>
            <IconButton sx={{ position: "absolute", top: 16, left: 16 }}>
              <ArrowBackIcon sx={{ color: "#2C2C2C" }} />
            </IconButton>

            <Grid
              container
              sx={{
                borderRadius: 3,
                p: { xs: 0, sm: 1 },
                position: "relative",
              }}
            >
              <Grid item xs={12} lg={3} md={4}>
                <Box
                  component="img"
                  src={Salon_img}
                  alt="Salon"
                  sx={{
                    width: "100%",
                    height: "100%",
                    borderRadius: 2,
                    objectFit: "cover",
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={8}
                lg={9}
                sx={{ px: { md: 2, sm: 1, xs: 0 } }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "start",
                  }}
                >
                  <Box>
                    <Typography
                      variant="h5"
                      fontWeight={600}
                      fontSize={{ sm: 25, md: 30, xs: 20 }}
                    >
                      {details.enterpriseName}
                      <Typography
                        component="span"
                        fontWeight={500}
                        fontSize={{ sm: 25, md: 30, xs: 20 }}
                      >
                        (B.Id - {details.billerId ?? "N/A"})
                      </Typography>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: { sm: 15, md: 18, xs: 14 },
                        color: "#000",
                        mt: 0.5,
                        fontWeight: 500,
                      }}
                    >
                      {details.businessCategory}
                    </Typography>
                  </Box>
                  <IconButton onClick={handleFavoriteClick}>
                    {isFavorited ? (
                      <FavoriteIcon sx={{ color: "red" }} />
                    ) : (
                      <FavoriteBorderIcon sx={{ color: "#5A5A5A" }} />
                    )}
                  </IconButton>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                  <Box
                    component="img"
                    src={Clock_icon}
                    alt="Clock"
                    sx={{ width: 24, height: 24 }}
                  />
                  <Typography
                    fontSize={{ sm: 15, md: 18, xs: 14 }}
                    ml={2}
                    fontWeight={500}
                  >
                    {details.openingTime ?? "N/A"}-
                    {details.closingTime ?? "N/A"}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                  <Box
                    component="img"
                    src={Location_icon}
                    alt="Location"
                    sx={{ width: 24, height: 24 }}
                  />
                  <Typography
                    fontSize={{ sm: 15, md: 18, xs: 14 }}
                    ml={2}
                    fontWeight={500}
                  >
                    {details.address ?? "N/A"}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                  <Box
                    component="img"
                    src={Mail_icon}
                    alt="Email"
                    sx={{ width: 24, height: 24 }}
                  />
                  <Typography fontSize={18} ml={2} fontWeight={500}>
                    {details.mailID1 ?? "N/A"}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: { xs: 1, sm: 1 },
                    mt: 2,
                    mb: 1,
                  }}
                >
                  {[
                    {
                      text: "Business Details",
                      icon: Details_icon,
                      onClick: () => navigate(routePath.DETAILS),
                    },
                    {
                      text: "Business Profile",
                      icon: Profile_icon,
                      onClick: () => navigate(routePath.PROFILEPAGE),
                    },
                    { text: "Whatsapp Enquiry", icon: Enquiry_icon },
                    { text: "Parlour Directions", icon: Map_icon },
                  ].map(({ text, icon, onClick }) => (
                    <Button
                      key={text}
                      onClick={onClick}
                      variant="outlined"
                      size="small"
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        border: "2px solid #B0B0B0",
                        color: "#000",

                        /* 🔑 Mobile layout fix */
                        flex: {
                          xs: "1 1 calc(50% - 8px)", // 2 buttons per row
                          md: "1 1 calc(40% - 10px)",
                          lg: "1 1 calc(25% - 10px)",
                        },

                        fontSize: {
                          xs: 11,
                          sm: 13,
                          md: 13,
                        },

                        px: {
                          xs: 1,
                          sm: 2,
                        },

                        minHeight: 40,

                        "&:hover": {
                          border: "2px solid #B0B0B0",
                          backgroundColor: "#CECEFF",
                          color: "#042E34",
                        },
                      }}
                      startIcon={
                        <Box
                          component="img"
                          src={icon}
                          alt={text}
                          sx={{
                            width: { xs: 18, sm: 22 },
                            height: { xs: 18, sm: 22 },
                          }}
                        />
                      }
                    >
                      {text}
                    </Button>
                  ))}
                </Box>

                <Button
                  size="small"
                  onClick={() => setOpen(true)}
                  sx={{
                    fontSize: { sm: 15, md: 16, xs: 14 },
                    textTransform: "none",
                    color: "#000EA7",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                  startIcon={
                    <Box
                      component="img"
                      src={Avatar_Img}
                      alt="Media"
                      sx={{ width: { sm: 60, xs: 40 } }}
                    />
                  }
                >
                  Media Links
                </Button>

                <Dialog
                  open={open}
                  onClose={() => setOpen(false)}
                  fullWidth
                  maxWidth="xs"
                >
                  <DialogTitle
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontWeight: 600,
                    }}
                  >
                    Media Links
                    <IconButton onClick={() => setOpen(false)} size="small">
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>

                  <Box sx={{ px: 2, pb: 2 }}>
                    {mediaLinks.map((link, index) => (
                      <Card
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          mb: 1,
                          px: 2,
                          py: 1,
                          boxShadow: 1,
                        }}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Box
                            component="img"
                            src={link.icon}
                            alt={link.name}
                            sx={{ width: 30, height: 30 }}
                          />
                          <Typography
                            sx={{
                              fontSize: 14,
                              color: "blue",
                              cursor: "pointer",
                            }}
                          >
                            {link.name}
                          </Typography>
                        </Box>

                        <Box>
                          <IconButton size="small">
                            <ContentCopyIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                          <IconButton size="small">
                            <ShareIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                        </Box>
                      </Card>
                    ))}
                  </Box>
                </Dialog>

                <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                  <Rating
                    value={details.totalRating}
                    precision={0.5}
                    readOnly
                    size="small"
                    sx={{
                      fontSize: { sm: "30px", xs: "20px" },
                      color: "orange",
                    }}
                  />
                  <Typography fontSize={14} sx={{ ml: 1, fontWeight: 500 }}>
                    {details.totalRating} ( {details.totalReview} Review)
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 2,
                    mt: 2,
                    mb: 1,
                  }}
                >
                  <Button
                    onClick={() => navigate(routePath.SERVICES)}
                    variant="contained"
                    sx={{
                      backgroundColor: "#01008B",
                      borderRadius: "6px",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      px: { sm: 6, xs: 2 },
                      textTransform: "none",
                      fontWeight: 500,
                    }}
                  >
                    Services & Products
                  </Button>
                  <Button
                    onClick={() => navigate(routePath.APPOINMENT)}
                    variant="outlined"
                    sx={{
                      borderRadius: "6px",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      px: { sm: 6, xs: 2 },

                      textTransform: "none",
                      fontWeight: 500,
                    }}
                  >
                    Book Appointment
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Container>
        <Box pb={6}>
          <Grid container>
            <Grid item xs={12} sx={{ paddingX: "20px" }}>
              <Typography
                sx={{
                  fontSize: { sm: "25px", xs: "18px" },
                  fontWeight: 700,
                  paddingLeft: "20px",
                }}
              >
                Offers and Deals
              </Typography>
              <Box sx={{ width: "100%", position: "relative" }}>
                <Button
                  ref={offersRef}
                  sx={{
                    position: "absolute",
                    height: { xs: "40px", sm: "100%" },
                    top: { xs: "50%", sm: "0" },
                    transform: { xs: "translateY(-50%)", sm: "none" },
                    minWidth: "40px", // Ensure it doesn't expand
                    width: "40px", // Reduced width
                    bottom: 0,
                    right: 0,
                    zIndex: 99,
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: "10px",
                    borderBottomRightRadius: "10px",
                    backgroundColor: "#01008b85",
                    color: "white",
                    "&:hover": { backgroundColor: "primary.dark" },
                  }}
                >
                  <ArrowForwardIosIcon />
                </Button>
                <Swiper
                  modules={[Navigation, Autoplay]}
                  spaceBetween={20}
                  // slidesPerView={4}
                  loop={true}
                  autoplay={{ delay: 3000 }}
                  onInit={(swiper) => {
                    swiper.params.navigation.nextEl = offersRef.current;
                    swiper.navigation.init();
                    swiper.navigation.update();
                  }}
                  breakpoints={{
                    1024: { slidesPerView: 4 },
                    768: { slidesPerView: 3 },
                    425: { slidesPerView: 2 },
                    375: { slidesPerView: 1 },
                    320: { slidesPerView: 1 },
                  }}
                >
                  {offersCarousel.map((item, idx) => (
                    <SwiperSlide key={idx}>
                      <Card
                        sx={{
                          padding: "4px",
                          boxShadow: "0px 4px 4px 0px #00000040",
                        }}
                      >
                        <CardContent>
                          <img
                            src={item.image}
                            alt="Offer"
                            style={{ width: "100%" }}
                          />
                          <Typography
                            sx={{ textAlign: "center", color: "primary.main" }}
                          >
                            {item.text}
                          </Typography>
                        </CardContent>
                      </Card>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ maxWidth: 800, mx: "auto", px: 2, mt: 4 }}>
          <Typography
            variant="h4"
            fontWeight={700}
            color="#01008B"
            fontSize={{ md: 30, sm: 20, xs: 18 }}
          >
            Ratings and Reviews
          </Typography>

          <Box mt={2}>
            <Typography fontSize={{ md: 30, sm: 25, xs: 20 }} fontWeight={700}>
              {details.totalRating}
              <Rating
                name="read-only"
                value={details.totalRating}
                readOnly
                precision={0.5}
                sx={{ verticalAlign: "middle", color: "#f9ae0e" }}
              />
            </Typography>
            <Typography fontSize={{ sm: 13, md: 14, xs: 12 }} color="gray">
              Total Reviews {details.totalReview}
            </Typography>
          </Box>

          <Box mt={2}>
            <Typography fontSize={{ sm: 13, md: 14, xs: 12 }} fontWeight={500}>
              Customer Review
            </Typography>

            <TextField
              multiline
              fullWidth
              minRows={4}
              placeholder="Share details of your own experience at this place"
              variant="outlined"
              value={reviewText}
              InputLabelProps={{
                className: "mulish",
                sx: {
                  color: "#545454",
                  fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  paddingX: "7px",
                },
              }}
              InputProps={{
                classes: { input: "mulish" },
                sx: {
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                },
              }}
              onChange={(e) => setReviewText(e.target.value)}
              sx={{
                mt: 2,
                backgroundColor: "#F1EEFF",
                borderRadius: 2,
                "& fieldset": {
                  borderColor: "#01008B",
                  borderWidth: "2px",
                },
              }}
            />

            <Button
              variant="contained"
              fullWidth
              sx={{
                mt: 2,
                backgroundColor: "#01008B",
                textTransform: "none",
                fontWeight: 600,
                fontSize: { sm: 13, md: 16, xs: 12 },
                borderRadius: 1,
              }}
            >
              Post
            </Button>
          </Box>

          <Divider sx={{ my: 3, borderColor: "#7C7CEC" }} />

          {reviews.slice(0, visibleReviews).map((review, index) => (
            <Box key={index} sx={{ mb: 3 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={Review_user_img}
                    alt="Offer"
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: 50,
                      marginRight: 10,
                    }}
                  />
                  <Typography
                    fontWeight={600}
                    fontSize={{ sm: 13, md: 14, xs: 12 }}
                  >
                    {review.profilename}
                  </Typography>
                </Box>
                <Typography fontSize={14} color="gray">
                  {review.createdDate.slice(0, 10)}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "inline-block",
                  mt: 1,
                  px: 2,
                  py: 0.3,
                  backgroundColor: "#1D1D8C",
                  borderRadius: "4px",
                }}
              >
                <Typography fontSize={12} color="#fff" fontWeight={600}>
                  {review.rating} ★
                </Typography>
              </Box>

              <Typography fontSize={14} mt={1}>
                {review.review}
              </Typography>

              <Divider sx={{ mt: 2 }} />
            </Box>
          ))}

          {reviews.length > 5 && (
            <Box textAlign="center">
              {visibleReviews < reviews.length ? (
                <Button
                  variant="outlined"
                  onClick={handleShowMore}
                  sx={{
                    my: 2,
                    textTransform: "none",
                    fontWeight: 600,
                    borderColor: "#1D1D8C",
                    color: "#1D1D8C",
                    "&:hover": {
                      backgroundColor: "#f0f0ff",
                      borderColor: "#1D1D8C",
                    },
                  }}
                >
                  Show More
                </Button>
              ) : (
                <Button
                  variant="outlined"
                  onClick={handleShowLess}
                  sx={{
                    my: 2,
                    textTransform: "none",
                    fontWeight: 600,
                    borderColor: "#1D1D8C",
                    color: "#1D1D8C",
                    "&:hover": {
                      backgroundColor: "#f0f0ff",
                      borderColor: "#1D1D8C",
                    },
                  }}
                >
                  Show Less
                </Button>
              )}
            </Box>
          )}
        </Box>

        {/* <ReviewAndRating /> */}
        {/* Use above component for reference or code */}

        <Footer />
      </Box>
    </>
  );
};
